import React from "react";
import { UserBox } from "./UserBox";
import {CheckoutDropdown} from "./CheckoutDropdown";
import {ModalCheckoutExtraOperation} from "./ModalCheckoutExtraOperation";
import {useCore} from "../hooks";
import {formatPrice} from "../utils";

export const CheckoutDetailHeader: React.FC = () => {
  const { checkouts, selectedDetailCheckoutId, currency, core } = useCore()
  const hasRoleExtraOperation = core.services.user.hasOneOfTheRoles(['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_CHECKOUT_EXTRA_OPERATION_CREATE'])
  const hasRoleShowProfit = core.services.user.hasOneOfTheRoles(['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_CHECKOUT_SHOW_PROFIT'])
  const selectedCheckout = checkouts?.find(c => c.id === selectedDetailCheckoutId)
  return (
    <div className="flex flex-row h-[var(--height-header)] bg-white border-b border-border-light pl-6 items-center">
      <CheckoutDropdown />
      {Number(selectedDetailCheckoutId) > 0 && (
        <div className="pl-4 pr-6">
          <div className="flex flex-row items-center justify-between"><span className="font-bold pr-6">Celková tržba pokladny</span> <span className="text-primary">{formatPrice(selectedCheckout?.currentClosing?.amountRealClosed || 0, currency.id)}</span></div>
          {/*<div className="flex flex-row items-center justify-between"><span className="font-bold pr-6">Zisk od otevření pokladny:</span> <span className="text-primary">{formatPrice((selectedCheckout?.currentClosing?.amountRealClosed - selectedCheckout?.currentClosing?.amountRealOpen) || 0, currency.id)}</span></div>*/}
          {hasRoleShowProfit ? <div className="flex flex-row items-center justify-between"><span className="font-bold pr-6">Zisk od otevření pokladny:</span> <span className="text-primary">{formatPrice(selectedCheckout?.currentClosing?.profit || 0, currency.id)}</span></div> : null}
          <div className="flex flex-row items-center justify-between"><span className="font-bold pr-6">Aktuální stav:</span> <span className="text-primary">{formatPrice(selectedCheckout?.amount || 0, currency.id)}</span></div>
        </div>
      )}
      {Number(selectedDetailCheckoutId) > 0 && hasRoleExtraOperation && <ModalCheckoutExtraOperation />}
      <div className="flex flex-row items-center justify-between pl-4 pr-4 ml-auto">
        <UserBox />
      </div>
    </div>
  )
}
